import { isString, isObject, isFunction } from 'util'

/*****************************API*************************** */

/**
 * @private
 */
const _beans = []

/**
 * 获取Beans
 * @api
 * @param {String | Function} v
 * @returns {Array}
 */
export function getBeans(v, ...rest) {
    const beans = _beans
        .filter(bean => checkBean(bean, v))
        .map(bean => creatBean(bean, ...rest))
        .filter(bean => bean !== null)
    return beans
}

/**
 * 获取Bean
 * @api
 * @param {String | Function} v
 * @returns {Object | null}
 */
export function getBean(v, ...rest) {
    const beanConfig = _beans.find(bean => checkBean(bean, v))
    if (beanConfig) {
        return creatBean(beanConfig, ...rest)
    }
    return null
}

function checkBean(bean, v) {
    const { id, zClass } = bean
    if (isString(v)) {
        return id === v
    }
    if (isObject(v) || isFunction(v)) {
        return v.isPrototypeOf(zClass) || zClass instanceof v || zClass === v
    } else {
        return false
    }
}

function creatBean(beanConfig, ...rest) {
    const { zClass, properties = {}, target } = beanConfig

    // 已经初始化
    if (target) {
        return target
    }

    try {
        const instance = new zClass(...rest)

        for (const key in properties) {
            instance[key] = properties[key]
        }

        // 赋值
        beanConfig.target = instance

        return instance
    } catch (error) {
        console.error('creat bean error:', error)
        return null
    }
}

/****************************INIT BEANS**************************** */
// 并非完全实现（第一阶段实现properties，value）
// bean 初始化说明（id， class路径， constructor：构造参数，properties：属性）
/*
{
    "id": "Erase",
    "class": "./operations/Erase",
    "constructor": [
        {
            "type": "ref",
            "value": ""
        },
        {
            "type": "value",
            "value": ""
        },
        {
            "type": "class",
            "value": ""
        }
    ],
    "properties": {
        "description": "Erase"
    }
}
*/
/**
 * beans 配置项（数组）
 * @type {Array}
 */
const config = require('./config.json')

config.forEach(item => {
    const { id, class: path, properties = {} } = item

    try {
        const zClass = require(`./${path}`).default
        if (isFunction(zClass)) {
            _beans.push({
                id,
                zClass,
                properties
            })
        } else {
            throw 'not available class'
        }
    } catch (error) {
        console.error('creat bean error:', path)
    }
})
